import { render, staticRenderFns } from "./ScrollGlobalHeader.vue?vue&type=template&id=28d16dd3"
import script from "./ScrollGlobalHeader.vue?vue&type=script&lang=ts"
export * from "./ScrollGlobalHeader.vue?vue&type=script&lang=ts"
import style0 from "./ScrollGlobalHeader.vue?vue&type=style&index=0&id=28d16dd3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports